module.exports = ":host {\n  width: 100%; }\n\n.multi-select-nests-input {\n  position: relative;\n  background-color: transparent; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/multi-select-events/multi-select-events.component.scss
// module id = ./src/app/common/multi-select-events/multi-select-events.component.scss
// module chunks = main